export interface AcquisitionSourceRow {
  sourceUrl: string
  sourceType: string
  scrapeMode: string
}

export function normalizeAcquisitionUrl(value: string): string {
  return value.trim().replace(/\/+$/, '')
}

export function isHttpGateway(value: string): boolean {
  try {
    const protocol = new URL(value).protocol
    return protocol === 'http:' || protocol === 'https:'
  } catch {
    return false
  }
}

export function isOpcEndpoint(value: string): boolean {
  try {
    const endpoint = new URL(value)
    return endpoint.protocol === 'opc.tcp:' && Boolean(endpoint.hostname)
  } catch {
    return false
  }
}

export function conversionSourceUrls(
  targetMode: 'poll' | 'subscribe',
  sourceUrl: string,
  destinationUrl: string
): { httpGatewayUrl: string; opcEndpointUrl: string } {
  const source = normalizeAcquisitionUrl(sourceUrl)
  const destination = normalizeAcquisitionUrl(destinationUrl)
  return targetMode === 'subscribe'
    ? { httpGatewayUrl: source, opcEndpointUrl: destination }
    : { httpGatewayUrl: destination, opcEndpointUrl: source }
}

export function acquisitionDestinationOptions(
  rows: readonly AcquisitionSourceRow[] | undefined,
  targetMode: 'poll' | 'subscribe'
): string[] {
  if (!rows?.length) return []
  return [
    ...new Set(
      rows
        .filter((row) =>
          targetMode === 'subscribe'
            ? row.sourceType === 'opcua' && row.scrapeMode === 'subscribe'
            : row.sourceType === 'ignition' && row.scrapeMode === 'poll'
        )
        .map((row) => normalizeAcquisitionUrl(row.sourceUrl))
        .filter((url) => (targetMode === 'subscribe' ? isOpcEndpoint(url) : isHttpGateway(url)))
    )
  ].sort()
}

export function resolveTagRegistrationAcquisition(
  enableScraping: boolean | 'preserve' | undefined,
  newTagsEnabled?: boolean
): {
  enabled: boolean
  preserveExistingEnabled: boolean
  preserveExistingAcquisition: boolean
} {
  const preserveExistingEnabled = enableScraping === 'preserve'
  return {
    enabled: preserveExistingEnabled ? newTagsEnabled === true : enableScraping !== false,
    preserveExistingEnabled,
    preserveExistingAcquisition: preserveExistingEnabled
  }
}
